import { getAppName, CompanyName, AppName } from 'modules/utils/ConfigUtils';

export const treatedConditions = [
  {
    condition: `Common Cold`,
    definition: [
      'An upper respiratory infection (URI) refers to an infection in your nose, throat, and sinuses (the hollow air spaces within the bones surrounding the nose).',
      'Common symptoms are a runny nose, sinus congestion, and sore throat. Symptoms are usually worse at night and get better within a week.',
      'URIs are most often caused by a virus. These viruses are easily spread through the air or on things you touch, like a handrail or doorknob.'
    ]
  },
  {
    condition: `Sinus Infection`,
    definition: [
      'Sinusitis is an infection of the hollow air spaces within the bones surrounding the nose. It is typically caused by a virus or bacteria.',
      'Common symptoms include pain or pressure in your face, sinus congestion, and runny nose.',
      'Most cases of sinusitis go away on their own after about a week. Sometimes they last longer and need to be treated with antibiotics.'
    ]
  },
  {
    condition: `Seasonal Allergies`,
    definition: [
      'Hay fever, also called allergic rhinitis [rine-EYE-tis], is your body’s way getting rid of pollen, grass, dust, mold or other particles in the air (allergens).',
      "Symptoms of hay fever include sneezing, coughing, itchy eyes, and runny nose. They usually start when the seasons are changing (because new pollen and dust is in the air) or when traveling to new places (because your body isn't used to the allergens there)."
    ]
  },
  {
    condition: `Sore Throat`,
    definition: [
      'Viral pharyngitis [fair-en-JIE-tiss] is the medical name for a sore throat.',
      'It is often caused by a virus that makes the throat red and painful. It can also make it hard to swallow, block up your sinuses, and cause a cough.',
      'You may have a sore throat when you have a stuffy or runny nose and a cough. Symptoms are usually worse at night and last less than a week.'
    ]
  },
  {
    condition: `Flu`,
    definition: [
      'The flu is caused by the influenza virus. It usually causes the same type of symptoms and is always very contagious. The type of virus that causes the flu is often different each year.',
      'Most people with the flu get better within 5 to 7 days with home remedies and medications you can find at the drug or grocery store.',
      'Some people (babies, older people, and people with other medical problems) might require more intense treatment or even hospitalization to recover.',
      'You can avoid the flu by wearing a mask, washing your hands, and avoiding close contact with other people.'
    ]
  },
  {
    condition: `Asthma`,
    definition: [
      'Asthma is a chronic (long-term) disease that affects your airways. Asthma can cause your airways to narrow and swell and produce extra mucus. This can make breathing difficult and trigger coughing, wheezing and shortness of breath.',
      "Asthma can't be cured, but its symptoms can be controlled."
    ]
  },
  {
    condition: `Headache`,
    definition: [
      'A headache is just that – an ache in your head. It can happen in any part of your head, for example, behind the eyes, around the ears, or in the upper part of your neck.',
      "Some headaches don't have specific, obvious causes. They can be tied to stress, not drinking enough water, caffeine withdrawal, or menstrual periods. Headaches can last anywhere from 30 minutes to several days.",
      'Headaches can be treated with over-the-counter pain medicine such as ibuprofen, aspirin, or acetaminophen.  Relaxation, sleep, and diet changes can also help.'
    ]
  },
  {
    condition: `Pink Eye`,
    definition: [
      'Conjunctivitis [con-junk-tiv-EYE-tiss] is the medical term for pink eye. Pink eye is an inflammation or infection of the conjunctiva [con-junk-TIE-vah] – the transparent membrane that lines the eyelid and covers the white part of the eyeball.',
      'Pink eye is commonly caused by a bacterial or viral infection. It is passed easily from person to person. The best way to avoid it is to wash your hands often.'
    ]
  },
  {
    condition: `Sty`,
    definition: [
      'A sty is a red, painful lump on or in the eyelid that may look like a boil or a pimple. Stys are caused by blocked glands in the eyelid that become inflamed. Although they are painful, they usually resolve on their own after a few days.',
      'If you have a sty, don’t wear contact lenses. Place warm washcloths on the area help to relieve any pain or discomfort.'
    ]
  },
  {
    condition: `Stomach Virus/ Stomach Flu`,
    definition: [
      'Gastroenteritis [gas-troh-en-ter-EYE-tiss] is an infection in the stomach and intestines (gut). It can be caused by bacteria or viruses in food or drinks.',
      'Common symptoms include diarrhea, nausea, vomiting, belly pain, loss of appetite, and fevers.',
      'This condition usually gets better within a week with rest and lots of fluids.'
    ]
  },
  {
    condition: `Urinary Tract Infection/ UTI Bladder Infection`,
    definition: [
      'A urinary tract infection (UTI) is an infection in any part of your urinary system, usually in the bladder.',
      "It's often caused by not drinking enough water, taking antibiotics, poorly treated diabetes, or poor hygiene – though sometimes the cause is unknown.",
      'Common symptoms include a burning sensation with while peeing, a strong urge to pee, pressure in the lower belly, or low back pain. Fevers, vomiting, or severe back pain are uncommon.',
      'UTIs are common and easily treated. Once treatment starts, the symptoms tend to improve in 1 to 2 days.'
    ]
  },
  {
    condition: `Vaginal Yeast Infection`,
    definition: [
      'A vaginal yeast infection is caused by a fungus called Candida that exists naturally in the vagina but has grown a little out of control.',
      'It can be caused by poor hygiene, diabetes, antibiotics — though sometimes the cause is unknown.',
      'Common symptoms include itching inside and outside of the vagina. You may have a thick, white discharge for a few days too. With treatment, symptoms should start to get better in a couple days.'
    ]
  },
  {
    condition: `New Low Back Pain`,
    definition: [
      'Low back pain is common. Most people have it at some time in their life.',
      'Low back pain can be acute (new or unusual, or caused by an injury) or chronic (long term). It may also be caused by an illness or other medical condition.',
      'Symptoms of low back pain include stiffness or decreased movement of the lower back. You may also have a hard time standing straight.',
      'Treatment will vary depending on the cause. '
    ]
  }
];

export const treatedConditionsFrontDoor = [
  {
    termCode: 'acute_upper_respiratory_infection',
    condition: `Head Cold / Cough`,
    definition: [
      'The common cold is a viral infection of the upper respiratory tract. The first symptoms of a cold are often a tickle in the throat, a runny or stuffy nose, and sneezing. If you have a cold, you might feel very tired and have a sore throat, cough, headache, mild fever, muscle aches, and loss of appetite.'
    ]
  },
  {
    termCode: 'acute_upper_respiratory_infection',
    condition: `Sinus Infection`,
    definition: [
      'Sinus infections are caused by swelling or inflammation in the lining of the sinuses and nose. Symptoms include: sinus pressure, headache, facial pain or pressure, congestion, cough, runny nose, ear pressure and teeth pain. The majority of sinus infections are caused by a virus, not a bacteria, so antibiotics are not always needed or prescribed.'
    ]
  },
  {
    termCode: 'allergic_rhinitis',
    condition: `Seasonal Allergies`,
    definition: [
      'Seasonal allergies typically happen during times of the year when plants release tiny pollen particles into the air. Allergy symptoms can include sneezing, itchy nose and/or throat, nasal congestion, runny nose, and postnasal drip. These symptoms often come with itchy, watery, and/or red eyes.'
    ]
  },
  {
    termCode: 'viral_pharyngitis',
    condition: `Sore Throat`,
    definition: [
      'Sore throats are common at any age and can be one of the first signs of other illness. Symptoms of a sore throat include fever, white patches, pain, scratchiness, swollen glands in the neck, or irritation in the throat that often gets worse when you swallow.'
    ]
  },
  {
    termCode: 'acute_upper_respiratory_infection',
    condition: `Flu`,
    definition: [
      'The flu is a respiratory illness caused by influenza viruses that infect the nose, throat, and lungs. Symptoms of the flu include fever, chills, cough, body aches, headaches, and sometimes sinus problems. It can also cause nausea, vomiting, or diarrhea.'
    ]
  },
  {
    termCode: 'covid_19',
    condition: `COVID-19`,
    definition: [
      'COVID-19 can cause a range of symptoms including fever, cough, trouble breathing, and gastrointestinal problems like bellyache, nausea, vomiting, and diarrhea. Other complaints include headaches, muscle aches, loss of taste and smell, and cold symptoms. '
    ]
  },
  {
    termCode: 'conjunctivitis',
    condition: `Pink Eye`,
    definition: [
      'Pink eye is an inflammation of the white part of the eye and the inner eyelids. Symptoms include a red or pink color in the eye, eye discomfort that is commonly described as the feeling like sand is in the eye, and sometimes discharge from the eye.'
    ]
  },
  {
    termCode: 'hordeolum_externum',
    condition: `Stye`,
    definition: [
      'A stye is a red, painful bump on the eyelid caused by a backed-up oil gland. Styes may look like a boil or pimple and are often filled with pus.'
    ]
  },
  {
    termCode: 'gastroenteritis',
    condition: `Nausea / Vomiting / Diarrhea`,
    definition: [
      'Nausea, vomiting, diarrhea, and belly cramps are often signs of the stomach flu. It is a common illness that usually lasts a few days. These symptoms could also be due to food poisoning.'
    ]
  },
  {
    termCode: 'urinary_tract_infection',
    condition: `Bladder / Urinary Tract Infections`,
    definition: [
      'A urinary tract infection (UTI) is an infection that is more common in females than males. UTI symptoms include pain while peeing, frequent urination, low back pain or abdominal pain near the bladder, fever, and foul-smelling urine that may look cloudy or contain blood.'
    ]
  },
  {
    termCode: 'vaginal_yeast_infection',
    condition: `Vaginal Yeast Infection`,
    definition: [
      'Vaginal yeast infections are a fungal infection that can cause irritation and itchiness of the vagina. Symptoms include redness, swelling, or itching of the vulva (the folds of skin outside the vagina), a thick, white discharge, and pain or burning when urinating.'
    ]
  }
];

export const conditionDefinitionsScreen = {
  title: 'More information: Conditions treated with E-Visits'
};

export const notificationsButtonsText = (hasChannelsEnabled: boolean) => {
  switch (hasChannelsEnabled) {
    case true:
      return {
        title: "We'll notify you when your treatment plan is ready.",
        topButton: 'Manage notifications',
        bottomButton: 'Close'
      };
    default:
      return {
        title:
          'Check back for your results. If you would like to be notified when your treatment plan is ready please setup notifications.',
        topButton: 'Setup notifications',
        bottomButton: "No, I'll check for updates manually"
      };
  }
};

export const eVisitFrontDoorConditionsScreen = {
  screenTitle: 'E-Visit',
  sectionTitle: {
    headerText: 'What is the reason for this visit?',
    descriptionText: 'Select one of the following conditions we treat:'
  }
};

export const eVisitSuccessText = {
  title: 'Your E-Visit has been sent to the provider for review',
  estimatedTime: 'Estimated response time is 1-2 hours*',
  footer: [
    '* Estimations based on normal business hours and may vary at night.',
    'If you need assistance please contact us at'
  ],
  phone: '(801) 442-2610'
};

export const eVisitFAQs = [
  {
    title: 'Who can use an E-Visit?',
    content: `E-Visits are currently available to adults (18+) with their own ${getAppName(
      AppName.base,
      '',
      AppName.suffix3
    )} (no proxies) and those with eligible insurance. E-Visits are for those with basic medical concerns listed in the Common Conditions Treated section above.`
  },
  {
    title: 'When should I expect a reply?',
    content:
      'Intermountain providers should review and respond with a treatment plan or escalate to an appropriate level of care within 1-2 hours.'
  },
  {
    title: 'How do I pay for my E-Visit?',
    content: `${CompanyName} checks your insurance to be sure you are eligible and will bill any charges following your visit. If you have received a charge and don’t feel it is appropriate, please contact the Connect Care billing department at 801-906-2800.`
  },
  {
    title: 'Who will treat me for my E-Visit encounter?',
    content: `An Intermountain urgent care provider will review your Symptom Checker notes and create a treatment plan for you. The plan will be sent to you in your ${getAppName(
      AppName.base,
      '',
      AppName.suffix3
    )} and stored in your ${CompanyName} medical record.`
  },
  {
    title: 'I have SelectHealth. Can I use an E-Visit?',
    content:
      'E-Visits are available on most SelectHealth commercial plans (non-Medicare/Medicaid/CHIP). Please reach out to your insurer if you have any questions.'
  },
  {
    title:
      'The provider said I needed to seek care in another way after I was eligible for a E-Visit. What’s that about?',
    content:
      'E-Visits are designed for a specific group of common medical conditions, and we aim to complete as many as possible. However, based on your personal medical history or condition the provider may feel it appropriate to escalate you to another form of care, such as a video visit, an urgent care, or a visit with your primary care provider. We strive to care for you at the lowest price possible, but your visit may be escalated to ensure that you receive the care that you need.'
  }
];

export const eVisitInsuranceErrorMessage = 'Error loading your insurance card. Please try again.';
